var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsImportTargetService, Target } from './import-target.service';
var KtsImportTargetComponent = /** @class */ (function (_super) {
    __extends(KtsImportTargetComponent, _super);
    function KtsImportTargetComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        _this.rec = new Target();
        _this.target = [];
        _this.supervisor = [];
        _this.step = [];
        _this.task = [];
        return _this;
    }
    KtsImportTargetComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var mode = jsonpath.value(this.component, '$.params.mode');
        if (typeof mode !== 'undefined') {
            this.defMode = mode;
        }
        this.getType();
        this.setCompRec();
    };
    KtsImportTargetComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsImportTargetComponent.prototype.onSubscribe = function (data) {
        if (typeof data.id !== 'undefined') {
            this.projectMId = data.id;
            this.rec = new Target();
            this.getSupervisor();
            this.getTask(this.rec.step);
        }
        this.setCompRec();
    };
    KtsImportTargetComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('IMPORT_TARGET').subscribe(function (rec) { return _this.target = rec; });
        this.service.getType('IMPORT_STEP').subscribe(function (rec) {
            _this.step = rec;
            _this.getTask(_this.step.length > 0 ? _this.step[0].code : null);
        });
    };
    KtsImportTargetComponent.prototype.getSupervisor = function () {
        var _this = this;
        if (!this.projectMId) {
            return;
        }
        this.service.setBaseUrl('/v1/gen/construction-supervisor-m-api?query={"predicateList":[{"name":"project_m.id","value":"' + this.projectMId + '","operator":"eq"}],"orderByList":[{"name":"id","direction":"asc"}]}');
        this.service.getList(this.msgSnapshot).subscribe(function (rec) { return _this.supervisor = rec; });
    };
    KtsImportTargetComponent.prototype.getTask = function (step) {
        var _this = this;
        if (!this.projectMId) {
            return;
        }
        var url = '';
        var s;
        if (step === 'outline') {
            url = '/v1/gen/task-outline-m-api?query={"predicateList":[{"name":"project_m.id","value":"' + this.projectMId + '","operator":"eq"}],"orderByList":[{"name":"disp_order","direction":"asc"}]}';
        }
        else if (step && (s = step.match(/^step(\d+)$/)) !== null) {
            url = '/v1/gen/task-m-api?query={"predicateList":[{"name":"project_m.id","value":"' + this.projectMId + '","operator":"eq"},{"name":"step","value":"' + s[1] + '","operator":"eq"}],"orderByList":[{"name":"disp_order","direction":"asc"}]}';
        }
        if (url) {
            this.service.setBaseUrl(url);
            this.service.getList(this.msgSnapshot).subscribe(function (rec) {
                _this.task = rec;
                _this.rec.task = _this.task.length > 0 ? _this.task[0].code : null;
                _this.setCompRec();
            });
        }
        else {
            this.task = [];
            this.task.push({ code: 'all', display: this.msgSnapshot['au.COMPONENT.KtsImportTargetComponent.select.all'] });
            this.rec.task = this.task[0].code;
        }
    };
    KtsImportTargetComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.getType();
            this.getSupervisor();
        }
    };
    KtsImportTargetComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsImportTargetComponent.prototype.onChange = function (e) {
        if (e.key === 'target' && e.val === 'all') {
            this.rec.step = this.step.length > 0 ? this.step[0].code : null;
            this.getTask(this.rec.step);
        }
        this.rec[e.key] = e.val;
        this.setCompRec();
    };
    KtsImportTargetComponent.prototype.onChangeStep = function (e) {
        this.getTask(e.val);
        this.onChange(e);
    };
    KtsImportTargetComponent.prototype.setCompRec = function () {
        var rec = Object.assign({}, this.rec);
        if (rec.target === 'all') {
            delete rec.step;
            delete rec.task;
        }
        this.action.setCompRec(this.componentName, rec);
    };
    KtsImportTargetComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-import-target',
                    template: "<form *ngIf=\"defMode === '' || defMode === mode\" id=\"{{ componentName }}\">\n  <div *ngIf=\"target.length > 0\" class=\"row -mb-1\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        label: (msg | async)['au.COMPONENT.KtsImportTargetComponent.label.target'],\n        key: 'target',\n        controlType: 'select',\n        required: true,\n        params: {options: target}\n      }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <div *ngIf=\"supervisor.length > 0\" class=\"row\" [class.-mb-1]=\"rec.target !== 'all'\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        label: (msg | async)['au.COMPONENT.KtsImportTargetComponent.label.supervisor'],\n        key: 'supervisor',\n        controlType: 'select',\n        required: true,\n        params: {options: supervisor}\n      }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <ng-template [ngIf]=\"rec.target !== 'all'\">\n    <div *ngIf=\"step.length > 0\" class=\"row -mb-1\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['au.COMPONENT.KtsImportTargetComponent.label.step'],\n          key: 'step',\n          controlType: 'select',\n          required: true,\n          params: {options: step}\n        }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeStep($event)\"></column>\n      </div>\n    </div>\n    <div *ngIf=\"task.length > 0\" class=\"row\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['au.COMPONENT.KtsImportTargetComponent.label.task'],\n          key: 'task',\n          controlType: 'select',\n          required: true,\n          params: {options: task}\n        }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsImportTargetComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsImportTargetService }
    ]; };
    return KtsImportTargetComponent;
}(ContentBaseComponent));
export { KtsImportTargetComponent };
//# sourceMappingURL=import-target.component.js.map